/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function BusCancellationPolicy({ cancellationPolicyString }) {
  const [cancellationRules, setCancellationRules] = useState([]);

  useEffect(() => {
    // calculate cancellation rules
    let cancellations =
      cancellationPolicyString !== '-'
        ? cancellationPolicyString.split(';')
        : [];
    cancellations = cancellations.filter((d) => d !== '');
    const rules = cancellations.map((c) => {
      const time = c.split(':');
      return {
        time: time[0],
        rule: time[1],
      };
    });
    setCancellationRules(rules);
  }, []);

  return (
    <section className="fw-500">
      {cancellationRules.length > 0
        ? cancellationRules.map((d, index) => (
            <div className="d-flex justify-content-between mt-1" key={index}>
              <span>{d.time}</span>
              <span>{d.rule}</span>
            </div>
          ))
        : 'N/A'}
    </section>
  );
}

BusCancellationPolicy.propTypes = {
  cancellationPolicyString: PropTypes.string.isRequired,
};

export default BusCancellationPolicy;
